import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { useDispatch } from "react-redux";
import FullPageLoader from "@src/common/FullPageLoader";
import CommissionListTable from "./commissionListTable";
import { getCommissionList } from "@store/slices/commission";
import CommonModel from "./commonModel";
import secureStorage from "@src/config/encrypt";
import { COMMISSION_MAIN_TAB, COMMISSION_MAIN_TAB_KEY, COMMISSION_SUB_TAB, COMMISSION_SUB_TAB_KEY, DASHBOAED_TILES } from "@src/config/id/constant";
import * as HELPER from "@src/config/helper";
import { useLanguage } from "@src/context/LanguageContext";
import { CURRENCY_SYMBOL } from "@src/config/constant";


function CommissionList() {
  let auth = secureStorage.getItem("authAgentUserInfo");
  let commission_type = secureStorage.getItem("commission_type");
  
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [commissionList, setCommissionList] = useState<any>([]);
  const {translations} = useLanguage();
  
  const [activeTabs, setActiveTabs] = useState<any>({
    mainTab:  commission_type == DASHBOAED_TILES.POTENTIAL_EARNING ? COMMISSION_MAIN_TAB_KEY.POTENTIAL_PAYMENT: COMMISSION_MAIN_TAB_KEY.ACTAUL_EARNING,
    subTab: COMMISSION_SUB_TAB_KEY.ALL,
  });


  const now = new Date();
  const formatLocalDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  const initFilters = {
    from_date: formatLocalDate(new Date(now.getFullYear(), now.getMonth(), 1)),
    to_date: formatLocalDate(now),
    filter_params: {
      earning_type: commission_type == DASHBOAED_TILES.POTENTIAL_EARNING ? COMMISSION_MAIN_TAB[COMMISSION_MAIN_TAB_KEY.POTENTIAL_PAYMENT]: COMMISSION_MAIN_TAB[COMMISSION_MAIN_TAB_KEY.ACTAUL_EARNING],
    },
    page_number: 1,
    user_id: auth?.user_data?.id,
  };
  const [selectedFilters, setSelectedFilters] = useState<any>(initFilters);

  useEffect(() => {
    getCommissionListing(selectedFilters);
  }, []);

  const getCommissionListing = (params: any) => {
    let filters: any = { ...params };
    setLoading(true);
    dispatch(getCommissionList(filters))
      .then((res: any) => {
        setLoading(false);
        if (res.status === 200) {
          setCommissionList(res);
        }
      })
      .catch((err: Error) => {
        setLoading(false);
      });
  };

  const activeTabHandler = (mainTab: any, subTab: any = "") => {
    const updatedTabs = { ...activeTabs };
    const updatedFilters = { ...selectedFilters };
    if (mainTab) {
      updatedTabs["mainTab"] = mainTab;
      updatedFilters["filter_params"]['earning_type'] = COMMISSION_MAIN_TAB[mainTab];
      setSelectedFilters(updatedFilters);
    }
    if (subTab) {
      updatedTabs["subTab"] = subTab;
      updatedFilters["type"] = COMMISSION_SUB_TAB[subTab];

    }
    setActiveTabs(updatedTabs);
    getCommissionListing(updatedFilters);
  };

  const setSearchKeyword = (searchKey: any) => {
    const updatedFilters: any = { ...selectedFilters };
    if(searchKey){
      updatedFilters["search_text"] = searchKey ? searchKey : "";
    }else{
      if(updatedFilters["search_text"]) delete updatedFilters["search_text"];
    }
    setSelectedFilters(updatedFilters);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      getCommissionListing(selectedFilters);
      if(selectedFilters?.search_text){
        
      }
    }
  };
  const openModel = () => {
    setShowFilterPopup(true);
  };


  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const handleFilterPopupClose = () => {
    setShowFilterPopup(false);
  };

  // current month show with year , diff month show range
  const getDateDisplayText = () => {
  if (selectedFilters?.from_date && selectedFilters?.to_date) {
    const fromDate = new Date(selectedFilters.from_date);
    const toDate = new Date(selectedFilters.to_date);

    const fromMonth = fromDate.getMonth();
    const fromYear = fromDate.getFullYear();
    const toMonth = toDate.getMonth();
    const toYear = toDate.getFullYear();

    if (fromMonth === toMonth && fromYear === toYear) {
      return HELPER.formatDate(fromDate, "mon yyyy");
    }

    const from = HELPER.formatDate(fromDate, "dd mon yyyy");
    const to = HELPER.formatDate(toDate, "dd mon yyyy");

    return `${from} - ${to}`;
  }

  return HELPER.formatDate(new Date(), "mon yyyy");
};

  
  return (
    <React.Fragment>
      <FullPageLoader show={loading} />
      <CommonModel
        show={showFilterPopup}
        handleClose={handleFilterPopupClose}
        filterType={translations?.COMMON_MSG?.FILTER_BY}
        showDateRange={true}
        buttonTitle={translations?.COMMON_MSG?.APPLY}
        api={getCommissionListing}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        className="commission-filter-popup"
      ></CommonModel>
      <div className="container-fluid wap-bg-white">
        <div className=" insurnace-appliction-table-outer commission-list-outer m-lg-t">
          <div className="top-heading d-flex comission-list-heading">
            <h1>{translations?.COMMISSION?.POINT_AND_COMMISSION}</h1>
            <div className="d-flex">
              <fieldset className="search-bx">
                <div
                  className="material"
                  title={translations?.COMMISSION?.SEARCH}
                >
                  <input
                    id=""
                    type="text"
                    placeholder={translations?.COMMISSION?.SEARCH}
                    name="RoleName"
                    className="form-input lead_search_input"
                    value={selectedFilters?.search_text || ""}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <i className="ic-search"></i>
                </div>
              </fieldset>
              <button
                type="button"
                className="btn-line btn-lg m-sm-l btn-filter"
                onClick={() => {
                  openModel();
                }}
              >       
              {translations?.COMMON_MSG?.FILTER_BY}
              <i className="ic-filter m-sm-l"></i>
              </button>
            </div>
           
 
          </div>
          {activeTabs?.mainTab && (
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={activeTabs?.mainTab}
            >
             
              <Nav
                variant="pills"
                className="flex-column tab-line nav nav-pills"
                onSelect={(k) => activeTabHandler(k)}
              >
                <div className="tab-list tab-line-bottom">
                  <Nav.Item>
                    <Nav.Link eventKey={COMMISSION_MAIN_TAB_KEY.ACTAUL_EARNING}>
                    {translations?.COMMISSION?.ACTUAL_EARNINGS}
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey={COMMISSION_MAIN_TAB_KEY.POTENTIAL_PAYMENT}>
                    {translations?.COMMISSION?.POTENTIAL_PAYMENTS}
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>


              <Tab.Content>
                {activeTabs?.subTab && (
                  <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey={activeTabs?.subTab}
                  >
                    <Nav
                      variant="pills"
                      className="flex-column nav nav-pills commission-point-tab"
                      onSelect={(k) => activeTabHandler(activeTabs?.mainTab, k)}
                    >
                      <div className='d-flex incentive-box'>
                          <div className="tab-list">
                          
                              <Nav.Item>
                                <Nav.Link eventKey={COMMISSION_SUB_TAB_KEY.ALL}>
                                  {translations?.COMMON_MSG?.ALL}(
                                  {commissionList?.data?.tab_data?.find(
                                    (tab: any) => tab.type === COMMISSION_SUB_TAB_KEY.ALL
                                  )?.value || 0}
                                  )
                                </Nav.Link>
                              </Nav.Item>

                              <Nav.Item>
                                <Nav.Link eventKey={COMMISSION_SUB_TAB_KEY.COMMISSION}>
                                  {translations?.COMMISSION?.COMMISSION} (
                                  {commissionList?.data?.tab_data?.find(
                                    (tab: any) => tab.type === COMMISSION_SUB_TAB_KEY.COMMISSION
                                  )?.value || 0}
                                  )
                                </Nav.Link>
                              </Nav.Item>

                              <Nav.Item>
                                <Nav.Link eventKey={COMMISSION_SUB_TAB_KEY.POINTS}>
                                  {translations?.COMMISSION?.POINTS}(
                                  {commissionList?.data?.tab_data?.find(
                                    (tab: any) => tab.type === COMMISSION_SUB_TAB_KEY.POINTS
                                  )?.value || 0}
                                  )
                                </Nav.Link>
                              </Nav.Item>
                          
                          </div>
                            <div className="incentive-card">
                              <div className="date-year">
                                <h3>{getDateDisplayText()}</h3>
                              </div>

                              <div className="total-incentive-point">
                                {
                                  activeTabs?.subTab===COMMISSION_SUB_TAB_KEY.COMMISSION && 
                                  <>
                                   <span>{translations?.COMMISSION?.TOTAL_COMMISSION}
                                   {` ${HELPER.addCurrencyFormatting(commissionList?.data?.summary?.total_commission_amount)}`}</span>
                                  </>
                                }
                                {
                                  activeTabs?.subTab===COMMISSION_SUB_TAB_KEY.POINTS &&
                                   <>
                                   <span>{translations?.COMMISSION?.TOTAL_POINTS}
                                  {` ${HELPER.addCurrencyFormatting(commissionList?.data?.summary?.total_points_amount)?.replace(CURRENCY_SYMBOL,translations?.COMMISSION?.PTS)}`}</span>
                                  </>
                                }
                                {
                                  activeTabs?.subTab===COMMISSION_SUB_TAB_KEY.ALL && 
                                   <>
            
                                      <span>{translations?.COMMISSION?.TOTAL_INCENTIVE}
                                    {` ${HELPER.addCurrencyFormatting(commissionList?.data?.summary?.total_all_amount)}`} </span>
                                    <p>({translations?.COMMISSION?.COMMISSION} {HELPER.addCurrencyFormatting(commissionList?.data?.summary?.total_commission_amount)} & {translations?.COMMISSION?.POINTS} {HELPER.addCurrencyFormatting(commissionList?.data?.summary?.total_points_amount)?.replace(CURRENCY_SYMBOL,'')})</p>
                                  </>
                                }
                              </div>
                            </div>

                      </div>
                    </Nav>

                    <Tab.Content>
                      <Tab.Pane eventKey={activeTabs?.subTab}>
                        <CommissionListTable
                          commissionList={commissionList.data?.items}
                          paginationData={commissionList?.pagination}
                          getCommissionListing={getCommissionListing}
                          selectedFilters={selectedFilters}
                          tab={activeTabs?.subTab}
                          mainTab={activeTabs?.mainTab}
                        />
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                )}
              </Tab.Content>
            </Tab.Container>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default CommissionList;
